/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import ls from 'local-storage';
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  OlsTaxRow, OlsShippingRow, OlsTotalRow,
} from '../../component/OlsRow';
import OlsItemRow from '../../component/OlsItemRow/OlsItemRow';
import OrderAlamatLengkap from '../../container/OrderAlamatLengkap/OrderAlamatLengkap';
import OrderLokasiPengiriman from '../../container/OrderLokasiPengiriman/OrderLokasiPengiriman';
import OlsBottomNav from '../../container/OlsBottomNav/OlsBottomNav';
import OlsItemEdit from '../../container/OlsItemEdit/OlsItemEdit';
import Toast from '../../component/Toast/Toast';
import Confirm from '../../component/Confirm/Confirm';
import 'typeface-roboto';
import WhatsAppLink from '../../component/WhatsAppLink/WhatsAppLink';

let isMounted = false;

const useStyles = (theme) => ({
  appBarWrapper: {
    backgroundColor: 'white',
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
    maxWidth: theme.palette.width.maxWidth,
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 'auto',
    right: 'auto',
    paddingRight: '0px !important',
  },
  appBarTitle: {
    position: 'relative',
    display: 'block',
    fontWeight: 'bold',
    marginLeft: 0,
    width: '100%',
  },
  appToolbar: {
    height: 62,
    minHeight: 62,
    maxHeight: 62,
  },
  appBarRightIcon: {
    display: 'flex',
  },
  content: {
    marginTop: 0,
    marginBottom: 60,
    padding: 4,
    display: 'block',
    minHeight: 1000,
  },
  itemWrapper: {
    marginTop: 0,
    padding: 0,
    display: 'block',
    width: '100%',
  },
  headerItemWrapper: {
    padding: '4px 4px 2px 4px',

  },
  headerItemContent: {
    borderRadius: '15px 15px 0px 0px',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    padding: 16,
    boxShadow: '1px 3px 1px #9E9E9E',
  },
  buttonStyle: {
    margin: '10px 0px',
    borderRadius: 0,
    padding: 15,
    fontWeight: 'bold',
  },
});

const { pathname } = window.location;
const arrPath = pathname.split('/');
const username = (arrPath && arrPath.length >= 3) ? arrPath[3] : '';

class ShoppingCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otl_info: ls.get(`${username}_info`) || {},
      order_info: {},
      item_list: [],
      loading: false,
      itemEdit: false,
      itemEditData: {},
      toastOpen: false,
      toastMessage: '',
      toastSeverity: 'info',
      confirmCheckout: false,
      confirmCancel: false,
    };
  }

  componentDidMount() {
    isMounted = true;
    if (isMounted) {
      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      const orderInfo = ls.get(lsShoppingCartOrderInfo);
      if (_.isObject(orderInfo)) {
        if (_.isString(orderInfo.order_uxid)) {
          this.setState({ order_info: orderInfo });
          const itemList = ls.get(lsShoppingCartItemList);
          if (_.isArray(itemList)) {
            this.setState({ item_list: itemList });
          }
        }
      }
      this.setState({ loading: true });
      axios.post(`https://eqiozmart.com/olsapi/olshop/order_info/${username}/`).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
        }
      });
    }
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    isMounted = false;
  }

  handleGoBack = () => {
    const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
    const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
    if (_.isString(this.state.order_info.order_step)) {
      if (this.state.order_info.order_step === 'CHECKOUT') {
        ls.set(lsShoppingCartOrderInfo, {});
        ls.set(lsShoppingCartItemList, []);
      }
    }
    if (this.props.history.length > 0) {
      this.props.history.goBack();
    }
  }

  handleAlamatLengkapChange = (dt) => {
    if (isMounted) {
      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('order_uxid', this.state.order_info.order_uxid);
      formdata.append('order_shipping_realname', dt.order_shipping_realname);
      formdata.append('order_shipping_address1', dt.order_shipping_address1);
      formdata.append('order_shipping_address2', dt.order_shipping_address2);
      formdata.append('order_shipping_address3', dt.order_shipping_address3);
      formdata.append('order_shipping_address4', dt.order_shipping_address4);
      formdata.append('order_shipping_address5', dt.order_shipping_address5);
      formdata.append('order_shipping_phone', dt.order_shipping_phone);
      axios.post('https://eqiozmart.com/olsapi/olshop/order_address_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleLokasiPengirimanChange = (dt) => {
    if (isMounted) {
      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('order_uxid', this.state.order_info.order_uxid);
      formdata.append('order_shipping_province_id', dt.order_shipping_province_id);
      formdata.append('order_shipping_province_name', dt.order_shipping_province_name);
      formdata.append('order_shipping_city_id', dt.order_shipping_city_id);
      formdata.append('order_shipping_city_name', dt.order_shipping_city_name);
      formdata.append('order_shipping_city_type', dt.order_shipping_city_type);
      formdata.append('order_shipping_subdistrict_id', dt.order_shipping_subdistrict_id);
      formdata.append('order_shipping_subdistrict_name', dt.order_shipping_subdistrict_name);
      axios.post('https://eqiozmart.com/olsapi/olshop/order_location_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleItemEditOpen = (data) => {
    if (isMounted) {
      if (this.state.order_info.order_step === 'CREATE') {
        this.setState({
          itemEdit: true,
          itemEditData: data,
        });
      }
    }
  }

  handleItemEditClose = () => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });
    }
  }

  handleItemEditDelete = (fields) => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });

      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('item_uxid', fields.item_uxid);
      formdata.append('item_amount', fields.item_amount);
      formdata.append('item_note', fields.item_note);
      axios.post('https://eqiozmart.com/olsapi/olshop/item_delete/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleItemEditSave = (fields) => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });

      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('item_uxid', fields.item_uxid);
      formdata.append('item_amount', fields.item_amount);
      formdata.append('item_note', fields.item_note);
      axios.post('https://eqiozmart.com/olsapi/olshop/item_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  toastShow = (severity, message) => {
    this.setState({
      toastOpen: true,
      toastMessage: message,
      toastSeverity: severity,
    });
  }

  toastOnClose = () => {
    this.setState({
      toastOpen: false,
    });
  }

  handleOrderCheckout = () => {
    this.setState({
      confirmCheckout: true,
    });
  }

  confirmCheckoutClose = () => {
    this.setState({
      confirmCheckout: false,
    });
  }

  confirmCheckoutYes = () => {
    if (isMounted) {
      this.setState({
        confirmCheckout: false,
      });

      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('order_uxid', this.state.order_info.order_uxid);
      axios.post('https://eqiozmart.com/olsapi/olshop/order_checkout/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleOrderCancel = () => {
    this.setState({
      confirmCancel: true,
    });
  }

  confirmCancelClose = () => {
    this.setState({
      confirmCancel: false,
    });
  }

  confirmCancelYes = () => {
    if (isMounted) {
      this.setState({
        confirmCancel: false,
      });

      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('order_uxid', this.state.order_info.order_uxid);
      axios.post('https://eqiozmart.com/olsapi/olshop/order_cancel/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
          window.scrollTo(0, 0);
        }
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        {_.size(this.state.item_list) <= 0
          && (
            <div>
              <div className={classes.appBarWrapper}>
                <AppBar className={classes.appBar}>
                  <Toolbar className={classes.appToolbar}>
                    <IconButton edge="start" color="inherit" onClick={this.handleGoBack}>
                      <ArrowBackIcon />
                    </IconButton>
                    <Typography className={classes.appBarTitle} variant="h6" noWrap>
                      Keranjang Belanja
                    </Typography>
                  </Toolbar>
                  <div style={{ marginBottom: -5, height: 5 }}>
                    <LinearProgress style={this.state.loading ? {} : { display: 'none' }} />
                  </div>
                </AppBar>
              </div>
              <div className={classes.content}>
                <div style={this.state.loading ? { display: 'none' } : {}}>
                  <div style={{ marginTop: '100px', textAlign: 'center' }}>
                    <ShoppingBasketIcon style={{ textAlign: 'center', color: '#808080', fontSize: 140 }} />
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <Typography style={{ color: '#808080' }} variant="h6" noWrap>
                      belum ada daftar belanja
                    </Typography>
                  </div>
                </div>
              </div>
              <OlsBottomNav />
            </div>
          )}
        {_.size(this.state.item_list) > 0
          && (
            <div>
              <div className={classes.appBarWrapper}>
                <AppBar className={classes.appBar}>
                  <Toolbar className={classes.appToolbar}>
                    <IconButton edge="start" color="inherit" onClick={this.handleGoBack}>
                      <ArrowBackIcon />
                    </IconButton>
                    <Typography className={classes.appBarTitle} variant="h6" noWrap>
                      Keranjang Belanja
                    </Typography>
                  </Toolbar>
                  <div style={{ marginBottom: -5, height: 5 }}>
                    <LinearProgress style={this.state.loading ? {} : { display: 'none' }} />
                  </div>
                </AppBar>
              </div>
              <div className={classes.content}>

                <OrderAlamatLengkap editable={(this.state.order_info.order_step === 'CREATE')} data={this.state.order_info} onChange={this.handleAlamatLengkapChange} />
                <OrderLokasiPengiriman editable={(this.state.order_info.order_step === 'CREATE')} data={this.state.order_info} onChange={this.handleLokasiPengirimanChange} />

                <div className={classes.headerItemWrapper}>
                  <div className={classes.headerItemContent}>
                    <Typography variant="h6" noWrap>
                      Daftar Belanja
                    </Typography>
                  </div>
                </div>

                <div className={classes.itemWrapper}>
                  {
                    this.state.item_list.map((item, index) => <OlsItemRow key={index} data={item} onOpen={(data) => this.handleItemEditOpen(data)} />)
                  }
                </div>

                {this.state.order_info.order_tax_percent > 0 && <OlsTaxRow percent={this.state.order_info.order_tax_percent} value={this.state.order_info.order_tax_value} />}
                {this.state.order_info.order_shipping_cost > 0 && <OlsShippingRow label="Biaya Pengiriman" value={this.state.order_info.order_shipping_cost} />}
                <OlsTotalRow label="Jumlah Total" value={this.state.order_info.order_total} />

                {this.state.order_info.order_step === 'CREATE'
                  && (
                    <div>
                      <Button className={classes.buttonStyle} fullWidth variant="contained" color="primary" onClick={this.handleOrderCheckout}>
                        KIRIM ORDER
                      </Button>
                      <Button className={classes.buttonStyle} fullWidth variant="contained" color="secondary" onClick={this.handleOrderCancel}>
                        BATALKAN ORDER
                      </Button>
                    </div>
                  )}

              </div>
              <OlsItemEdit data={this.state.itemEditData} onClose={this.handleItemEditClose} onSave={this.handleItemEditSave} onDelete={this.handleItemEditDelete} open={this.state.itemEdit} />
              <Confirm open={this.state.confirmCheckout} text="Yakin ingin mengirim order ke penjual?" onClose={this.confirmCheckoutClose} onYes={this.confirmCheckoutYes} />
              <Confirm open={this.state.confirmCancel} text="Yakin ingin membatalkan order?" onClose={this.confirmCancelClose} onYes={this.confirmCancelYes} />
              <WhatsAppLink phone={this.state.otl_info.otl_whatsapp} label="Butuh Bantuan ?" text="Bantu Cara Order" />
              <OlsBottomNav />
            </div>
          )}
        <Toast open={this.state.toastOpen} message={this.state.toastMessage} severity={this.state.toastSeverity} onClose={this.toastOnClose} />
      </div>
    );
  }
}

ShoppingCart.defaultProps = {
  data: {
    order_uxid: '',
    order_version: '',
    order_account_uxid: '',
    order_from_type: '',
    order_from_uxid: '',
    order_number: '',
    order_name: '',
    order_courier_code: '',
    order_courier_name: '',
    order_courier_service: '',
    order_courier_description: '',
    order_store_name: '',
    order_store_province_id: '',
    order_store_province_name: '',
    order_store_city_id: '',
    order_store_city_name: '',
    order_store_city_type: '',
    order_store_subdistrict_id: '',
    order_store_subdistrict_name: '',
    order_shipping_realname: '',
    order_shipping_code: '',
    order_shipping_phone: '',
    order_shipping_company: '',
    order_shipping_email: '',
    order_shipping_address1: '',
    order_shipping_address2: '',
    order_shipping_address3: '',
    order_shipping_address4: '',
    order_shipping_address5: '',
    order_shipping_location_id: '',
    order_shipping_province_id: '',
    order_shipping_province_name: '',
    order_shipping_city_id: '',
    order_shipping_city_name: '',
    order_shipping_city_type: '',
    order_shipping_subdistrict_id: '',
    order_shipping_subdistrict_name: '',
    order_shipping_note: '',
    order_shipping_detail: '',
    order_shipping_cost: 0,
    order_weight: '',
    order_value: 0,
    order_tax_percent: 0,
    order_tax_value: 0,
    order_discount_type: 0,
    order_discount_value: 0,
    order_discount_price: 0,
    order_total: 0,
    order_profit: 0,
    order_uxcode: 0,
    order_cash_pay: 0,
    order_cash_change: 0,
    order_note: '',
    order_step: '',
    order_payment_status: '',
    order_expired_status: '',
    order_mutasi_uxid: '',
    order_status: '',
    order_timestamp: 0,
    order_date: '',
    order_expired_datetime: '',
  },
};

export default withStyles(useStyles)(ShoppingCart);
